import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { useContext } from "react";
import { SiteProvider, SiteContext } from "./context/SiteContext";

// Componentes Globais
import Header from "./components/Header";
import Footer from "./components/Footer";
import AccessibilityMenu from "./components/AccessibilityMenu";
import VLibras from "./components/VLibras";

// Páginas
import Home from "./pages/Home";
import Noticias from "./pages/Noticias";
import NoticiaAberta from "./pages/NoticiaAberta";
import PaginaArea from "./pages/PaginaArea";
import PaginaEmpilhamento from "./pages/PaginaEmpilhamento";

import "./styles.css";

// Componente intermediário para validar o carregamento do subdomínio
function AppContent() {
  const { config, loading } = useContext(SiteContext);

  if (loading) {
    return (
      <div className="loader-container" style={{ minHeight: "100vh" }}>
        <div className="hexagon-spinner"></div>
        <p className="loader-text">Carregando portal...</p>
      </div>
    );
  }

  // Se o subdomínio não foi encontrado no banco ou não existe slug
  if (!config) {
    return (
      <div className="loader-container" style={{ minHeight: "100vh", textAlign: "center", padding: "20px" }}>
        <h1 style={{ fontSize: "2rem", marginBottom: "12px", color: "#1f2937" }}>Portal não encontrado</h1>
        <p style={{ color: "#6b7280" }}>
          Não identificamos um órgão correspondente a este endereço ({window.location.hostname}).
        </p>
      </div>
    );
  }

  return (
    <BrowserRouter>

      {/* 1. Plugins e Menus Flutuantes primeiro */}
      <AccessibilityMenu />
      <VLibras />

      {/* Header fixo */}
      <Header />

      <Routes>
        {/* Raiz do portal do cliente */}
        <Route path="/" element={<Home />} />

        {/* Notícias */}
        <Route path="/noticias" element={<Noticias />} />
        <Route path="/noticia/:id" element={<NoticiaAberta />} />

        {/* Categorias da Transparência (ex: /area/governanca, /area/transparencia) */}
        <Route path="/area/:areaSlug" element={<PaginaAreaWrapper />} />

        {/* Pilha de Documentos do item (ex: /area/governanca/item/302) */}
        <Route path="/area/:areaSlug/item/:itemId" element={<PaginaEmpilhamento />} />

        {/* 404 - Rota inexistente */}
        <Route
          path="*"
          element={
            <div className="container" style={{ padding: "60px 20px", textAlign: "center" }}>
              <h2>Página não encontrada</h2>
              <p style={{ marginTop: "8px", color: "#6b7280" }}>O endereço acessado não existe.</p>
            </div>
          }
        />
      </Routes>

      {/* Footer fixo */}
      <Footer />

    </BrowserRouter>
  );
}

// Wrapper para extrair o parâmetro areaSlug da URL e passar como prop para PaginaArea
function PaginaAreaWrapper() {
  const { areaSlug } = useParams();
  return <PaginaArea areaSlug={areaSlug} />;
}

export default function App() {
  return (
    <SiteProvider>
      <AppContent />
    </SiteProvider>
  );
}